import { render, staticRenderFns } from "./msgbox.vue?vue&type=template&id=0f8fa8e4&"
import script from "./msgbox.vue?vue&type=script&lang=js&"
export * from "./msgbox.vue?vue&type=script&lang=js&"
import style0 from "./msgbox.vue?vue&type=style&index=0&id=0f8fa8e4&prod&lang=scss&"
import style1 from "./msgbox.vue?vue&type=style&index=1&id=0f8fa8e4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports